export const enum AlertId {
    QuestionsAboutKindergeldOrKinderzuschlag,
    QuestionsAboutGruendungszuschussOrArbeitslosengeld,
    ContactAgencyOrQuestionsAboutArbeitslosengeld,
    CheckEntitlementToBuergergeldOrAskQuestions,
    CalculateKurzarbeitergeldOrAskQuestions,
    QuestionsAboutAusbildungOrStudium,
    QuestionsAboutWeiterbildung,
    QuestionsAboutUnternehmen,
    StartSeiteBot,
    FormBotDE,
    FormBotUA,
    InkassoAskQuestions,
}

export interface ChatbotAlert {
    id: string;
    text: string;
}

export function getAlert(id: AlertId): ChatbotAlert {
    switch (id) {
        case AlertId.QuestionsAboutKindergeldOrKinderzuschlag:
            return {
                id: "QuestionsAboutKinderzuschlag",
                text: "<p>Haben Sie Fragen zum Kindergeld oder zum Kinderzuschlag?</p>",
            };
        case AlertId.QuestionsAboutGruendungszuschussOrArbeitslosengeld:
            return {
                id: "QuestionsAboutGruendungszuschussOrArbeitslosengeld",
                text: "<p>Haben Sie Fragen zum Gründungszuschuss oder Arbeitslosengeld?</p>",
            };
        case AlertId.ContactAgencyOrQuestionsAboutArbeitslosengeld:
            return {
                id: "ContactAgencyOrQuestionsAboutArbeitslosengeld",
                text: "<p>Möchten Sie Fragen zu Beratungs-, Geld- oder Förderleistungen der Agentur für Arbeit stellen?</p>",
            };
        case AlertId.CheckEntitlementToBuergergeldOrAskQuestions:
            return {
                id: "CheckEntitlementToBuergergeldOrAskQuestions",
                text: "<p>Möchten Sie Fragen zum Thema Bürgergeld stellen oder Ihren Anspruch auf Bürgergeld prüfen?</p>",
            };
        case AlertId.CalculateKurzarbeitergeldOrAskQuestions:
            return {
                id: "CalculateKurzarbeitergeldOrAskQuestions",
                text: "<p>Möchten Sie Ihr Kurzarbeitergeld berechnen oder Fragen stellen?</p>",
            };
        case AlertId.QuestionsAboutAusbildungOrStudium:
                return {
                    id: "QuestionsAboutAusbildungOrStudium",
                    text: "<p><b>Hast du eine Frage</b>?<br>Ich kann Dir Fragen zu deinen Möglichkeiten nach dem Schulabschluss beantworten.</p>",
                };
        case AlertId.QuestionsAboutWeiterbildung:
            return {
                id: "QuestionsAboutAusbildungOrStudium",
                text: "<p><b>Hast du eine Frage</b>?<br>Ich kann Dir Fragen zu deinen Möglichkeiten im Bereich Weiterbildung beantworten.</p>",
            };
        case AlertId.QuestionsAboutUnternehmen:
            return {
                id: "PINK",
                text: "<p><b>Haben Sie eine Frage</b>?<br>Ich kann Ihnen Fragen zu Themen im angemeldeten Bereich beantworten.</p>",
            };
        case AlertId.FormBotDE :
            return {
                id: 'QuestionsAboutFormularDE',
                text: '<p><b>Haben Sie Fragen?</b><br>Ich kann Ihnen helfen das Formular auszufüllen.</p>'
            }
        case AlertId.FormBotUA :
            return {
                id: 'QuestionsAboutFormularUA',
                text: '<p><b>Маєте запитання?</b><br>Я можу допомогти Вам заповнити анкету.</p>'
            }
        case AlertId.InkassoAskQuestions :
            return {
                id: 'InkassoAskQuestions',
                text: '<p>Haben Sie Fragen zum Inkasso-Service? Ich kann versuchen Ihnen zu helfen.</p>'
            }
        case AlertId.StartSeiteBot:
            return {
                id: "StartSeiteBot",
                text: "<p><b>Haben Sie eine Frage</b>?</p><p>Ich kann Ihnen Fragen zu vielen Themen beantworten.</p>",
            };
    }
}
